export const redirectTo = (url) => {
    typeof window !== 'undefined' ? (window.location.href = url) : '';
};
